import Component from "@ember/component";
export default Component.extend({
  tagName: "",
  label: "topic.create",
  btnClass: "btn-default",
});
